import ApplicationAdapter from "./application";

export default class CollaboratorAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/invite/create`;
  }

  urlForUpdateRecord() {
    return `${this.apiBaseUri}/customer/editcollaborator`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/customer/removecollaborator?collaboratorid=${id}`;
  }
}
